export function createFinderEmbedTransport({ replaceParams }) {
  function decorateUrl(value, params) {
    const url = new URL(value, window.location.href);

    if (!/^https?:$/.test(url.protocol)) {
      return value;
    }

    replaceParams(url.searchParams, params);

    if (value.startsWith("//")) {
      return `//${url.host}${url.pathname}${url.search}${url.hash}`;
    }

    return /^[a-z]+:/i.test(value) ? url.toString() : `${url.pathname}${url.search}${url.hash}`;
  }

  return Object.freeze({ decorateUrl });
}
